import Footer from "./small/Footer";
const Ranking = () => {
  const tableRow = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      <section className="ranking-banner">
        <div className="container">
          <div className="row">
            <h3 className="ranking-tit">Ranking</h3>
          </div>
        </div>
      </section>
      <main className="collection-page-bg">
        {/* <section className="nftrankingbanner">
          <div className="container">
            <div className="welcome-to-bg">
              <div className="row align-items-center">
                <div className="col-sm-3">
                  <img
                    className="left-img-ranking"
                    src="../../assets/images/ranking/leftimage.png"
                    alt=""
                  />
                </div>

                <div className="col-sm-9">
                  <h3 className="welcome-to-tit">
                    Welcome To NFT <span>Ranking</span>
                  </h3>
                  <p className="ranking-txt">
                    The top NFT’s on Metamuze, Ranked by volume, floor price and
                    other <span>Statistics</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="ranking-table-section">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="table-wrapper">
                  <table className="ranking-table">
                    <tr>
                      <th>Collection</th>
                      <th>Volume</th>
                      <th>Time in hours</th>
                      <th> Days</th>
                      <th> Item Price</th>
                      <th> Assets</th>
                      <th> Owners</th>
                    </tr>
                    {tableRow.map(() => {
                      return (
                        <tr>
                          <td>
                            <div className="table-collection">
                              <img
                                src="../../assets/images/ranking/prof-img.png"
                                alt=""
                              />

                              <div className="more-information">
                                <h6 className="table-tit">
                                  “ Skull Face Art Muertos “
                                </h6>
                                <div className="prof-flex p5">
                                  <img
                                    src="../../assets/images/ranking/prof-img2.png"
                                    alt=""
                                  />
                                  <div>
                                    <p className="owned-by">Owned By</p>
                                    <p className="team-muertos">Team Muertos</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>

                          <td>1500</td>
                          <td style={{ color: "#28D84F" }}>+3869%</td>
                          <td style={{ color: "#FB5B5B" }}>-386%</td>
                          <td>1500 SOL</td>
                          <td>5.9k</td>
                          <td>25k</td>
                        </tr>
                      );
                    })}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default Ranking;
